export class Exploitation {
    usageHours = 0;
    operatingHours = 0;
    idleHours = 0;
    fuelUsed = 0;
    co2 = 0;
    startDate: Date;
    endDate: Date;

    exploitationDataByEquipmentIds: { [key: number]: ExploitationDataByEquipment } = {};

    usagePercent: string;
    operatingPercent: string;
    idlePercent: string;
    hourlyConsumption: string;
    co2EmissionsRate: string;
}

export class ExploitationDataByEquipment {
    usageHours = 0;
    operatingHours = 0;
    idleHours = 0;
    fuelUsed = 0;
    CO2 = 0;

    equipementDisplayName: string;
}